import styled from 'styled-components';
import { colors } from '../theme';

export const TextFooter = styled.p`
  font-family: Poppins;
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  text-align: center;
  margin-top: 5%;
  color: ${colors.whiteThree};
`;
